import React from "react";
import logo from "../../src/assets/liquid-logo.png";

const About = () => {


  
  return (
    <div className="bg-transparent matchfont px-4 md:px-20 py-10">
      {/* Container */}
      <div className="md:max-w-6xl mx-auto flex flex-col gap-10">
        
        {/* Section 1 */}
        <div className=" rounded-lg p-6 md:p-8">
          <h2 className="text-xl md:text-4xl font-bold mb-4 text-center">
            TAKE A LOOK BEHIND THE SCENES
          </h2>
          <div className="w-full flex justify-center mb-4">
            {/* Image */}
            <img
              src="https://via.placeholder.com/500x300"
              alt="Scene Behind"
              className="rounded-md"
            />
          </div>
          <h3 className="text-2xl text-center my-8 md:text-3xl font-bold mb-8">
          OUR PHILOSOPHY
          </h3>
          {/* Description */}
          <div className="w-full text-justify flex flex-col gap-5 justify-center items-center">
          <p className="text-gray-700 md:w-[60%] leading-relaxed text-sm md:text-base">
          Everybody is talking about climate change, sustainability and 
environmental impact, but when it comes to the point to do a 
fundamental change we tend to fall back to our „comfort zone“ 
and the individual welfare is of a higher importance.
          </p>

          <p className="text-gray-700 md:w-[60%] leading-relaxed text-sm md:text-base">The constant development of natural dyes, enables that waste 
water can be turned into drinking water and devastated land can 
be reactivated by the organic residues from the natural dyes.</p>
 <p className="text-gray-700 md:w-[60%] leading-relaxed text-sm md:text-base">It is our responsibility to understand the consequences and avoid 
further damages to the environment in textile producing countries 
and their living conditions.</p>

<p className="text-gray-700 md:w-[60%] leading-relaxed text-sm md:text-base">Natural Dyeing offers a transparent, circular, and sustainable CO2-
neutral contribution to the solution for the immense climate 
changes caused by the textile industry the world and the extinction 
of every kind of life</p>


          </div>
        
        </div>

        {/* Section 2 */}
       <div className="flex justify-center items-center">
        <div className="md:w-[60%] rounded-lg p-6 md:p-8">
        <h3 className="text-xl md:text-3xl font-bold text-center mb-4">
            HOW TO RECOGNIZE US
          </h3>
          <div className="flex justify-center md:justify-start">
          <h3 className="text-sm text-center md:text-lg mb-4 text-red-500">
          IM ZEICHEN STIL VON DEN <br/>
          INGREDIENTS NACHZEICHNEN
          </h3>
          </div>
         
          <div className="grid grid-cols-1 gap-4">
            {/* Image 1 */}
            <div className="flex flex-col md:flex-row gap-2">
              <img
                src="https://via.placeholder.com/300x400"
                alt="Denim"
                className="rounded-md w-96 h-72"
              />
              <div className="flex flex-col">
              <p className="text-gray-700 text-xs md:text-sm mt-2">
              Every year, xxx of tons of textile waste 
are sent to landfills, and countries with 
large textile industries, like India, face 
significant environmental challenges 
due to the fast pace of consumer 
demand.</p>
<p className="mt-4">
Many companies promote their 
sustainability efforts, but often don't 
address the full production chain. This 
can leave consumers unsure about what 
makes a product truly sustainable, with 
many different certifications that can be 
hard to navigate.
</p>
</div>
            </div>
            {/* Image 2 */}
           
          </div>
          <div className="flex justify-center md:justify-end mt-8">
          <h3 className="text-sm md:text-lg text-center mb-4 text-red-500">
          VIELLEICHT AUCH EINE <br/>
ZEICHNUNG, WO MAN ES FINDEN <br/>
KANN AUF EINEM TSHIRT
          </h3>
          </div>
         
          <div className="grid grid-cols-1 mt-8 gap-4">
            {/* Image 1 */}
            <div className="flex flex-col md:flex-row gap-2">
            
              <div className="flex flex-col">
              <p className="text-gray-700 text-xs md:text-sm mt-2">
              When you purchase a Liquid garment, 
you can trace the entire production 
process and feel confident that your 
item has been naturally dyed with ecofriendly methods</p>
<p className="mt-4">
Look for the unique embroidery on the 
sleeves or hem to identify a truly 
naturally dyed shirt from our collection
</p>
</div>
<img
                src="https://via.placeholder.com/300x400"
                alt="Denim"
                className="rounded-md w-96 h-72"
              />
            </div>
            {/* Image 2 */}
           
          </div>
        </div>
        </div>
        {/* Section 3 */}
        <div className="flex w-full h-96 justify-center">
          <img
            src="https://via.placeholder.com/200x200"
            alt="Technology Sample"
            className="rounded-md w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="bg-transparent px-4 py-10 md:py-20 md:px-20">
      {/* Container */}
      <div className="max-w-6xl mx-auto space-y-16">

        {/* Partners Section */}
        <section className=" p-6 md:p-12 text-center">
          <h2 className="text-xl md:text-3xl font-bold text-gray-800 mb-6">OUR PARTNERS</h2>
          <p className="text-gray-600 text-sm md:text-base text-justify leading-relaxed mb-6">
          Together with our partners from the WELTHUNGER HILFE , the GIZ, the 
European Union and the farmers association we collaborate to strengthen the 
people most affected by the pollution of synthetic dyes. The farmers are the 
backbone of , regenerating the soils, clean water and stable job opportunities 
through the production of natural dyes ares just a few of our core objectives….
          </p>
          {/* Image */}
          <div className="flex justify-center mb-6">
            <img
              src="https://via.placeholder.com/600x300"
              alt="Partners"
              className="rounded-md w-full md:w-2/3"
            />
          </div>
          {/* Logos */}
          <div className="flex flex-col items-center md:flex-row flex-wrap justify-center gap-8 mt-6">
            <div className="w-16 md:w-20">
             <p>LOGO<br/>Welthunger</p>
            </div>
            <div className="w-16 md:w-20">
             <p>LOGO<br/>GIZ </p>
            </div>
            <div className="w-16 md:w-20">
             <p>LOGO<br/>EU</p>
            </div>
            <div className="w-16 md:w-20">
             <p>LOGO<br/>Assoc. 
             </p>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className=" rounded-lg p-6 md:p-12">
          <h2 className="text-sm md:text-3xl font-bold text-gray-800 mb-6 text-center">
            HELP US SPREAD THE MESSAGE
          </h2>
          <p className="text-gray-600 text-center font-bold my-8 text-sm md:text-base mb-6">
          Every LIKE every FOLLOW or SUBSCRIPTION helps us to 
spread the story and brings us closer to our goal of a more 
transparent & sustainable fashion Industry.
          </p>

          <div className="flex flex-col justify-center my-8 items-center">
            <img src={logo} className="w-40 h-40 object-contain"/>
            <p className="font-bold text-sm text-center">Officialy Commited to <br>
            </br>QUALITY,TRANSPARENCY,& SUSTAINABLITY</p>
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-8 items-center">

            {/* Left: Contact Details */}
           

            {/* Right: Form */}
            <div className="w-full md:w-1/2">
              <form className="space-y-4">
                <input
                  type="text"
                  placeholder="Your Name"
                  className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="email"
                  placeholder="Your Email"
                  className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  placeholder="Subject"
                  className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500"
                />
                <textarea
                  placeholder="Your Message"
                  rows="4"
                  className="w-full border p-2 rounded-md focus:ring-2 focus:ring-blue-500"
                ></textarea>
                <button
                  type="submit"
                  className="bg-[#264374] text-white px-4 py-2 rounded-md hover:bg-blue-700 w-full"
                >
                  Send Message
                </button>
              </form>
            </div>
            <div className="flex flex-col items-start text-left space-y-4">
              <h3 className="font-bold text-gray-700">We can't Wait to hear from you</h3>
              <div className="space-y-1 text-gray-600 text-sm">
                <p>+1 (234) 567-890</p>
                <p>support@example.com</p>
                <p>123 Sustainability Street, Green City</p>
              </div>
              <div>
            <div className="map-container" style={{ width: "100%", height: "100px" }}>
      <iframe
        src="https://maps.google.com/maps?q=PLACE_NAME&t=&z=13&ie=UTF8&iwloc=&output=embed"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        title="Static Google Map"
      ></iframe>
    </div>

            </div>
            </div>
           
          </div>
        </section>
      </div>
    </div>
    </div>
  );
};

export default About;
